import React from 'react'

export default function Terms() {
  return (
    <div>Terms</div>
  )
}
